// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","510":"component---src-pages-terms-js","826":"component---src-pages-delete-account-js"}[chunkId] || chunkId) + "-" + {"293":"2ef4f42ed21d34d5d2ad","454":"794562760ecce700629a","510":"97cb571c2e6004722fe0","826":"fd2a4cff05244f2a4ffa"}[chunkId] + ".js";
};